//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { DatasetContext } from '@/contexts/DatasetContext';

/**
 * Access the dataset slice (active dataset + dataset list state, and the
 * dataset CRUD methods).  Consumers that only need dataset state subscribe
 * here, so they re-render on dataset changes only — not on unrelated
 * query/config state changes.
 *
 * setActiveDataset is the canonical selection setter: it validates against the
 * dataset list and persists to the user profile before updating front-end state
 * (async, and a no-op for an unchanged or unknown dataset).
 */
export function useDataset() {
  const context = useContext(DatasetContext);
  if (!context)
    throw new Error('useDataset must be used within a DatasetProvider');

  return context;
}
